import { formatDate } from "../../../../functions/dateTime/formatDate";

const DisableUserList = ({
  filteredUsers,
  selectedUsers,
  isSelectionMode,
  handleUserSelect,
  setUserViewDetails,
  handleEnableDialog,
}) => {
  return (
    <tbody className="text-light-black">
      {filteredUsers.map((user, ind) => {
        const isChecked = selectedUsers.includes(user.id);
        return (
          <>
            <tr key={ind} className="bg-white hover:bg-gray-50 border-b">
              {isSelectionMode && (
                <td className="p-3">
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={() => handleUserSelect(user.id)}
                    className="w-4 h-4 accent-input"
                  />
                </td>
              )}
              <td className="px-4 py-2">{user.id}</td>
              <td className="px-4 py-2">{user.fullName}</td>
              <td className="px-4 py-2">{user.email}</td>
              <td className="px-4 py-2">{formatDate(user.disabledAt)}</td>
              <td className="px-4 py-2">
                <button
                  className="px-4 py-[3px] bg-dBlue-100 text-dark-blue rounded-full text-sm hover:bg-dark-blue hover:text-white transition"
                  onClick={() => setUserViewDetails(user)}
                >
                  View
                </button>
              </td>
              <td className="px-4 py-2">
                <button
                  className="bg-teal-600 hover:bg-teal-500 px-4 py-[3px] text-white rounded-lg text-sm hover:text-white transition"
                  onClick={() =>
                    handleEnableDialog({
                      id: user.id,
                      name: user.fullName,
                    })
                  }
                >
                  Enable
                </button>
              </td>
            </tr>
          </>
        );
      })}
    </tbody>
  );
};

export default DisableUserList;
